module.exports = __webpack_public_path__ + "static/media/fx_sistemas_logo.facde225.png";